<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <loading :active.sync="loading" :can-cancel="false" :is-full-page="true"></loading>
      <div>
        <b-tabs class="mr-3 ml-3">

          <b-tab class="p-0">
            <template #title>
              Configuración Externa
            </template>
            <b-row>
              <b-col>
                <p style="color: #17a2b8; font-weight: 600" class="mt-2 ml-2">Modificar Configuración Clínica</p>
              </b-col>
            </b-row>
            <div class="scrollPorTabs">
              <b-row class="mb-3">
                <b-col cols="12">
                          <b-form-group>
                            <label for="configuraciones">Configuraciones</label>
                            <input type="text" placeholder="Buscar Configuración" v-model="nombreConfiguracion">
                          </b-form-group>
                          <b-row cols="2" cols-md="4" cols-lg="6" style="height: 400px; overflow-y: auto">
                            <template v-for="config in configuracionBase" >
                              <b-col v-bind:key="config.value" v-if="config.nombreConfiguracionClinica.toUpperCase().includes(nombreConfiguracion.toUpperCase())">
                                <b-form-checkbox style="text-align: left"
                                                 switch
                                                 :disabled="config.disabled"
                                                 v-model="config.activo"
                                                 @click.native.prevent="activarDesactivarConfiguracion(config)">
                                  {{config.nombreConfiguracionClinica}}
                                  <b-spinner small v-if="config.disabled"></b-spinner>
                                </b-form-checkbox>
                              </b-col>
                            </template>
                          </b-row>
                </b-col>
              </b-row>
            </div>
          </b-tab>

          <b-tab class="p-0">
            <template #title>
              Configuración General <em class="admiracion" variant="danger" v-show="invalidoEce" ></em>
            </template>

            <b-row>
              <b-col>
                <p style="color: #17a2b8; font-weight: 600" class="mt-2 ml-2">Configuración</p>
              </b-col>
            </b-row>
            <div class="scrollPorTabs">
              <b-row class="mb-3">
                <b-col cols="12" md="8" lg="8">
                  <b-row>
                    <b-col class="pl-0 mb-4" cols="5">
                      <div class="formularios marginformularios"
                           style="display:flex;align-items:center">
                        <b-form-checkbox
                            v-if="$localStorageService.can('BO_28_Descentralizado')"
                            id="descentralizado"
                            class="formularios marginformularios"
                            v-model="objGuardar.puedeHdx"
                            switch
                            @change=activarHdxClinica(objGuardar.idClinica,objGuardar.strNombre,!objGuardar.puedeHdx)
                            name="check-button">
                          ¿Tiene descentralizado?
                        </b-form-checkbox>
                      </div>
                    </b-col>
                    <b-col class="pl-0 mb-4" cols="5">
                      <div class="formularios marginformularios"
                           style="display:flex;align-items:center">
                        <b-form-checkbox
                            v-if="$localStorageService.can('BO_28_Activar_ECE')"
                            id="ece"
                            class="formularios marginformularios"
                            v-model="objGuardar.activarEce"
                            unchecked-value="false"
                            switch
                            @change=activarECEClinica(objGuardar.idClinica,objGuardar.activarEce)
                            name="check-button">
                          <span :class="invalidoEce ? 'subrayarTexto':''">¿Tiene activo el ECE?</span>
                        </b-form-checkbox>
                      </div>
                    </b-col>
                    <b-col cols="2"></b-col>
                    <b-col class="pl-0 mb-4" cols="5">
                      <div class="formularios marginformularios"
                           style="display:flex;align-items:center">
                        <b-form-checkbox
                            v-if="$localStorageService.can('BO_28_Comision_Bloque')"
                            id="comisionBloque"
                            class="formularios marginformularios"
                            v-model="objGuardar.comisionBloque"
                            switch
                            @change=activarComisionBloque(objGuardar.idClinica,objGuardar.strNombre,objGuardar.comisionBloque)
                            name="check-button">
                          ¿Tiene comision bloque?
                        </b-form-checkbox>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="12" sm="12" md="4" lg="4">
                  <b-row class="mr-2" v-if="$localStorageService.can('BO_28_Activar_ECE') && objGuardar.activarEce===true" >
                    <b-col cols="12" class="contenedorTablaSinColor" >
                      <br>
                      <b-col class="mb-3">
                        <span style="color: #0c69a7; font-weight: 600" :class="invalidoEce ? 'subrayarTexto':''">Activar expedientes clínicos</span>
                      </b-col>
                      <template v-for="config in configuracionBaseEce" >
                        <b-col cols="12" v-bind:key="config.value" v-if="config.nombreConfiguracionClinica.toUpperCase().includes(nombreConfiguracion.toUpperCase())">
                          <b-form-checkbox style="text-align: left;"
                                           class="blue"
                                           :disabled="config.disabled"
                                           v-model="config.activo"
                                           @click.native.prevent="activarDesactivarConfiguracionEce(config)">
                            {{config.nombreConfiguracionClinica}}
                            <b-spinner small v-if="config.disabled"></b-spinner>
                          </b-form-checkbox>
                        </b-col>
                      </template>
                      <br>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </div>
          </b-tab>

          <b-tab class="p-0" v-if="$localStorageService.can('Conf_TDC_clinica')">
            <template #title>
              Configuración TDC
            </template>

            <b-row>
            <TdcClinica :mesesProps="meses"
                        :bancosProps="bancos"
                        :idClinicaProp="objGuardar.idClinica"
                        :configuracionesMsiProps="configuracionesMsi"
                        @obtenerConfiguracionPlazos="obtenerConfiguracionPlazos"
                        :cargandoPF="cargandoPF"
            />
            </b-row>
          </b-tab>

        </b-tabs>
      </div>
  </div>
</template>

<script>

import TdcClinica from "@/version5/catalogos/TdcClinica";
export default {
  name: "configuracion",
  components: {
    TdcClinica

  },
  props:{
    clinicaOriginal: Object,
    meses: Array,
    bancos: Array,
  },
  data(){
    return{
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      cargandoPF: false,
      loading:false,
      objGuardar: {
        idClinica: null,
        strNombre: null,
        strNombreCorto: null,
        numeroSillones: null,
        capacidad:null,
        strLatitud: 0,
        strLongitud: 0,
        blnWeb: false,
        idPrecio: null,
        idUbicacion: null,
        idZona: null,
        idKcli: null,
        kRegion: null,
        kunitProd: null,
        kSubClient: null,
        idTipoClinica: null,
        idCategoria: null,
        strRFC: null,
        blnMercadoPago: false,
        blnTransferenciaElectronica: false,
        blnSeccionNinos: false,
        idCrm: null,
        idTipoSdi: null,
        codigoPostal: null,
        calle: null,
        noExterior: null,
        noInterior: null,
        nombreEstado: null,
        municipio: null,
        colonia: null,
        tel1: null,
        tel2: null,
        tel3: null,
        blnTurismoMedico: false,
        strMapa: '',
        blnRegistraIngresos: false,
        prueba:null,
        escanerFits: false,
        dias: [
          {start_time: '00:00', end_time: '23:59',day: 'Lunes',value:1},
          {start_time: '00:00', end_time: '23:59',day: 'Martes',value:2},
          {start_time: '00:00', end_time: '23:59',day: 'Miercoles',value:3},
          {start_time: '00:00', end_time: '23:59',day: 'Jueves',value:4},
          {start_time: '00:00', end_time: '23:59',day: 'Viernes',value:5},
          {start_time: '00:00', end_time: '23:59',day: 'Sabado',value:6},
          {start_time: '00:00', end_time: '23:59',day: 'Domingo',value:7}
        ],
      },

      nombreConfiguracion: '',
      configuracionBase: [],
      configuracionBaseEce: [],
      configuraciones:[],
      invalidoEce: false,
      configuracionesMsi: [],
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.inicializar();
    this.objGuardar = JSON.parse(JSON.stringify(this.clinicaOriginal));
  },
  methods:{

    activarECEClinica(idClinica, estatus) {
      this.loading = true;
      const parametros = {idClinica: idClinica}
      this.$http
          .post(this.$api + "catalogos/activarEceClinica", parametros)
          .then(() => {
            if(estatus!=true) {
              this.$swal.fire({
                position: "center",
                icon: "success",
                title: "Se activo ECE de la clínica con ID " + idClinica,
                showConfirmButton: false,
                timer: 3500,
              });
            }else{
              this.$swal.fire({
                position: "center",
                icon: "success",
                title: "Se desactivo ECE de la clínica con ID " + idClinica,
                showConfirmButton: false,
                timer: 3500,
              });
            }
            this.invalidoEce = false;
          }).finally(() => {
        this.loading = false;
        this.$emit("buscarClinicas");
      });
    },
    activarHdxClinica(idClinica, strNombre, estatus) {
      this.loading = true;
      const parametros = {idClinica: idClinica}
      this.$http
          .post(this.$api + "catalogos/activarHdxClinica", parametros)
          .then(() => {
            if(estatus==true) {
              this.$swal.fire({
                position: "center",
                icon: "success",
                title: "Se activo descentralización para la clínica " + strNombre,
                showConfirmButton: false,
                timer: 3500,
              });
            }else{
              this.$swal.fire({
                position: "center",
                icon: "success",
                title: "Se desactivo descentralización para la clínica " + strNombre,
                showConfirmButton: false,
                timer: 3500,
              });
            }
          }).finally(() => {
        this.loading = false;
        this.$emit("buscarClinicas");
      });
    },
    activarComisionBloque(idClinica, strNombre, estatus) {
      const parametros = {idClinica: idClinica}
      this.loading = true;
      this.$http
          .post(this.$api + "catalogos/cambiarEstatusComisionBloque", parametros)
          .then(() => {
            if(estatus!=true) {
              this.$swal.fire({
                position: "center",
                icon: "success",
                title: "Se activo la comisión de bloque para la clínica " + strNombre,
                showConfirmButton: false,
                timer: 3500,
              });
            }else{
              this.$swal.fire({
                position: "center",
                icon: "success",
                title: "Se desactivo la comisión de bloque para la clínica " + strNombre,
                showConfirmButton: false,
                timer: 3500,
              });
            }
          }).finally(() => {
        this.loading = false;
        this.$emit("buscarClinicas");
      });
    },

    async inicializar() {
      await this.obtenerConfiguracionesClinica();
      await this.obtenerConfiguracionesCatalogo();
      await this.obtenerConfiguracionesCatalogoECE();
      await this.obtenerConfiguracionPlazos();
    },
    async obtenerConfiguracionPlazos() {
      this.cargandoPF = true;
      const params = { idClinica: this.clinicaOriginal.idClinica }
      await this.$http.post(this.$api + "plazoFijo/obtenerDetalleMsi", params).then(response => {
            if (response.data.data) {
              this.cargandoPF = false;
              this.configuracionesMsi = response.data.data;

              this.configuracionesMsi.forEach(c => {
                c.loaderInactivar = false;
              })
            }
          }
      )
    },
    async obtenerConfiguracionesCatalogo() {
      await this.$http.get(this.$api + "configuracionClinica/obtenerConfiguracionesClinica").then(response => {
            if (response.data.data) {
              this.configuracionBase = response.data.data;
              this.initConfiguracionesEdit();
            }
          }
      )
    },
    async obtenerConfiguracionesCatalogoECE() {
      await this.$http.get(this.$api + "configuracionClinica/obtenerConfiguracionesClinicaEce").then(response => {
            if (response.data.data) {
              this.configuracionBaseEce = response.data.data;
              this.initConfiguracionesEditEce();
            }
          }
      )
    },
    async obtenerConfiguracionesClinica(){
      const parametros = {idClinica: this.clinicaOriginal.idClinica}
      await this.$http.post(this.$api + "configuracionClinica/obtenerConfiguracionesPorIdClinica", parametros).then(response => {
            if (response.data.data) {
              this.configuraciones = response.data.data;
            }
          }
      )
    },
    initConfiguracionesEdit() {
      this.configuracionBase.forEach(it => {
        it.disabled=false;
        it.activo=this.configuraciones.some((idp) => idp.idConfiguracionClinica === it.idConfiguracionClinica);
        it.r
      });
    },
    initConfiguracionesEditEce() {
      this.configuracionBaseEce.forEach(it => {
        it.disabled=false;
        it.activo=this.configuraciones.some((idp) => idp.idConfiguracionClinica === it.idConfiguracionClinica);
        it.r
      });
    },
    activarDesactivarConfiguracion(config) {
      this.configuraciones.map((c)=>{
        if(c.idConfiguracionClinica === config.idConfiguracionClinica){
          config['idRConfiguracion'] = c.idRConfiguracion;
        }
      });
      const estatusActual = config.activo;
      config.activo = !config.activo;
      config.disabled = true;
      config['idClinica'] = this.clinicaOriginal.idClinica;
      this.$forceUpdate();
      this.$http.post(this.$api + 'configuracionClinica/guardarConfiguracionClinica', config).then(respuesta => {

        this.$bvToast.toast(respuesta.data.message, {
          title: 'Atajo 1',
          noAutoHide: false,
          autoHideDelay: 3000,
          variant: 'primary',
          solid: true
        })

      }).catch(error => {
        console.error(error.data);
        this.$bvToast.toast("Ocurrio un error al realizar la asignación", {
          title: 'Atajo 1',
          noAutoHide: false,
          autoHideDelay: 3000,
          variant: 'primary',
          solid: true
        })

        config.activo = estatusActual;
      }).finally(() => {
        config.disabled = false;
        this.$forceUpdate();
      });
    },
    activarDesactivarConfiguracionEce(config) {
      this.configuraciones.map((c)=>{
        if(c.idConfiguracionClinica === config.idConfiguracionClinica){
          config['idRConfiguracion'] = c.idRConfiguracion;
        }
      });
      const estatusActual = config.activo;
      config.activo = !config.activo;
      config.disabled = true;
      config['idClinica'] = this.clinicaOriginal.idClinica;
      this.$forceUpdate();
      this.$http.post(this.$api + 'configuracionClinica/guardarConfiguracionClinica', config).then(respuesta => {

        this.$bvToast.toast(respuesta.data.message, {
          title: 'Atajo 1',
          noAutoHide: false,
          autoHideDelay: 3000,
          variant: 'primary',
          solid: true
        })
        this.invalidoEce = false;
      }).catch(error => {
        console.error(error.data);
        this.$bvToast.toast("Ocurrio un error al realizar la asignación", {
          title: 'Atajo 1',
          noAutoHide: false,
          autoHideDelay: 3000,
          variant: 'primary',
          solid: true
        })

        config.activo = estatusActual;
      }).finally(() => {
        config.disabled = false;
        this.$forceUpdate();
      });
    },
    tieneExpClinicos() {
      if (this.configuracionBaseEce.some(cbe => cbe.activo === true) && this.objGuardar.activarEce === true) {
        this.invalidoEce = false;
        return true;
      } else if (this.objGuardar.activarEce === true && !this.configuracionBaseEce.some(cbe => cbe.activo === true)) {
        this.invalidoEce = true;
        return false;
      } else {
        this.invalidoEce = false;
        return true;
      }
    }
  }
}
</script>

<style scoped>
.redondeo{
  border-radius: 10px !important;
}


b-form-checkbox[class="blue"] + span::before
{
  border: solid 1px blue;
  background: #B2DBFF;
  background: -moz-radial-gradient(#B2DBFF, #dfdfdf);
  background: -webkit-radial-gradient(#B2DBFF, #dfdfdf);
  background: -ms-radial-gradient(#B2DBFF, #dfdfdf);
  background: -o-radial-gradient(#B2DBFF, #dfdfdf);
  background: radial-gradient(#B2DBFF, #dfdfdf);
}

.subrayarTexto {
  border-bottom: medium solid #CC0000;
}


</style>